import { getLocalItem, setLocalItem } from "utils/localdb";

const BLOCK_STREAM_CAP_PROMO = "blockStreamCapPromo";

export function setStreamCapPromoBlockedCookie(value, opts) {
  setLocalItem(BLOCK_STREAM_CAP_PROMO, value, { expires: 7, ...opts });
}

export function getStreamCapPromoBlockedCookie() {
  return getLocalItem(BLOCK_STREAM_CAP_PROMO);
}
